import React from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardBody,
  Label,
} from "reactstrap";
import { useSafariPaymentReset } from "../../../hooks/useSafariPaymentReset";
import CustomInput from "../../../custom/CustomInput";
import CustomSelect from "../../../custom/CustomSelect";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import CircularIndeterminate from "../../loader/CircularIndeterminate";

const InstrumentalKeyboard = () => {
  const dispatch = useDispatch();
  const { isPostLoading } = useSelector((state) => state.coursereg);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const coursereg = {
      clientname: values.clientname,
      clientemail: values.clientemail,
      clientphone: values.clientphone,
      city: values.city,
      age: values.age,
      course_id: values.course_id,
      learning_mode: values.learning_mode,
      is_online_payment: values.is_online_payment,
      is_enquiry: values.is_enquiry,
    };
    dispatch(actions.postCourse(coursereg, setSubmitting, resetForm));
    setSubmitting(true);
    return;
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">Registration</h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  clientname: "",
                  clientemail: "",
                  clientphone: "",
                  age: "",
                  city: "Mumbai",
                  course_id: "363",
                  learning_mode: "",
                  is_enquiry: "1",
                  is_online_payment: "0",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  clientemail: Yup.string()
                    .required("Enter Your Email")
                    .email("Invalid Email address"),
                  clientname: Yup.string().required("required"),
                  clientphone: Yup.string().required("required"),
                })}
              >
                {(formProps) => {
                  return (
                    <Form className="mt-3">
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="clientname" className="label">
                            Enter Your Name:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientname"
                              id="clientname"
                              placeholder="Enter Your Name"
                              className={
                                "form-control" +
                                (formProps.errors.clientname &&
                                formProps.touched.clientname
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientname"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="clientemail" className="label">
                            Enter Your Email:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientemail"
                              id="clientemail"
                              placeholder="Enter Your Email"
                              className={
                                "form-control" +
                                (formProps.errors.clientemail &&
                                formProps.touched.clientemail
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientemail"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="clientphone" className="label">
                            Enter Your Mobile:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientphone"
                              id="clientphone"
                              placeholder="Enter Your Mobile"
                              className={
                                "form-control" +
                                (formProps.errors.clientphone &&
                                formProps.touched.clientphone
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientphone"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>

                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label htmlFor="city" className="label">
                            Enter Your City:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="city"
                              id="city"
                              placeholder="Enter Your City"
                              className={
                                "form-control" +
                                (formProps.errors.city && formProps.touched.city
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="city"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={12} className="mt-2">
                          <Label className="label">Enter Your Age:</Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="age"
                              id="age"
                              placeholder="Enter Your Age"
                              className={
                                "form-control" +
                                (formProps.errors.age && formProps.touched.age
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="age"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="learning_mode" className="label">
                            Learning Mode:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="learning_mode"
                              id="learning_mode"
                              placeholder="Select Learning Mode"
                              className={
                                "form-control" +
                                (formProps.errors.learning_mode &&
                                formProps.touched.learning_mode
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>Select Learning Mode</option>
                              <option value={"Online Classes"}>
                                Online Classes
                              </option>
                              <option value={"Home Tuitions in Mumbai"}>
                                Home Tuitions in Mumbai
                              </option>
                              <option value={"Branches in Mumbai"}>
                                Branches in Mumbai
                              </option>
                              <option value="Branches in Thane">
                                Branches in Thane
                              </option>
                              <option value="Branches in Bengaluru">
                                Branches in Bengaluru
                              </option>
                            </Field>
                            <ErrorMessage
                              name="learning_mode"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <div className="mt-3 mb-3 row">
                        <div className="col-12">
                          <Button
                            type="submit"
                            className="register-btn"
                            size="md"
                            block
                          >
                            {isPostLoading ? (
                              <CircularIndeterminate />
                            ) : (
                              "REGISTER"
                            )}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default InstrumentalKeyboard;
